function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "icon-image"
}, "Image Icon-");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.5,29V51h25V29ZM27,26H53a2.5,2.5,0,0,1,2.5,2.5v23A2.5,2.5,0,0,1,53,54H27a2.5,2.5,0,0,1-2.5-2.5v-23A2.5,2.5,0,0,1,27,26Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 32.5,
  cy: 34,
  r: 2.5
});

var SvgIconImage = function SvgIconImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "icon-image",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "icon-image"
  }, title) : null, _ref3, React.createElement("path", {
    d: "M34,51.72l7.41-10.91a2,2,0,0,1,2.78-.54,2.51,2.51,0,0,1,.47.45l8.34,11Z",
    style: {
      fillRule: "evenodd"
    }
  }), _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-image.8c8fa14e.svg";
export { ForwardRef as ReactComponent };